import { Action } from 'redux';

import { IncrementRouterSpaceReactKey } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';

export interface IncrementRouterSpaceReactKeyAction extends Action {}

export function incrementRouterSpaceReactKey(): IncrementRouterSpaceReactKeyAction {
  return {
    type: IncrementRouterSpaceReactKey
  };
}
export const isIncrementRouterSpaceReactKeyAction
  = isActionFactory<IncrementRouterSpaceReactKeyAction>(IncrementRouterSpaceReactKey);
